module.exports = __webpack_public_path__ + "static/media/10b.d5a0efc2.svg";